import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { validateResponse } from "@/api/validateResponse";
import { ContactOverviewSchema, type ContactOverview } from "@/api/types/contactOverview";

/** GET /api/v2/contacts/{id}/overview — the Contact 360 page's single fetch. */
export function useContactOverview(contactId: string | undefined) {
  return useQuery<ContactOverview>({
    queryKey: ["contacts", contactId, "overview"],
    queryFn: async () => {
      const { data } = await apiClient.get(`/v2/contacts/${contactId}/overview`);
      return validateResponse(
        ContactOverviewSchema,
        data,
        "GET /v2/contacts/:id/overview",
      );
    },
    enabled: !!contactId,
    staleTime: 15 * 1000,
  });
}
